<template>
  <PageTemplate :page="data" />
</template>

<script setup lang="ts">
  const { setDefaultDataLayer } = useSeo();
  const { domain } = useSetup();
  // Ovaj page će uhvatiti sve moguće url-ove
  const { page, meta, head, template, isWebsiteInited, get } = usePage()

  // Podaci za page koje ćemo prosljediti kao prop
  // Namjerno se ne koristi page iz usePage već prop data zato jer će se prilikom
  // svakog novog dohvaćanja podataka promjeniti podaci unutar usePage prije nego što
  // završi tranzicija s pagea na page, što može dovesti do problema

  // Dohvaćanje podataka za page s backenda ili preuzimanje podataka dohvaćenih na serveru
  const data = (isWebsiteInited.value ? await get() : page.value) as Page

  // Template komponenta
  const PageTemplate = defineAsyncComponent(async () => {
    try {
      return await import(`../templates/${template.value}.vue`)
    } catch (e) {
      console.dir(e)
      // Bacanje greške ako backend nije vratio template
      throw createError({
        statusCode: 404,
        statusMessage: 'Page not found',
        fatal: true
      })
    }
  })

  let hreflangList = [];
  const languageSwitcher = page.value?.language_switcher;
  if (languageSwitcher && Object.keys(languageSwitcher).length) {
    hreflangList = Object.keys(languageSwitcher).map((key) => {
      return {
        rel: 'alternate',
        hreflang: key,
        href: `${ domain.value }${ page.value.language_switcher[key] }`
      }
    })

    if (languageSwitcher['en']) hreflangList.push({ rel: 'alternate', hreflang: 'x-default', href: `${domain.value}${ languageSwitcher['en'] }` })
  }
  const combinedHead = computed(() => {
    let link = hreflangList;
    if (head.value.link) {
      link = [...hreflangList, ...head.value.link]
    }

    return {
      ...head.value,
      link,
    }
  });

  let breadcrumbsList = [];
  if (page.value?.breadcrumbs?.length) {
    breadcrumbsList = page.value.breadcrumbs.map((item, index) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "name": item.title,
        "item": item.url
      }
    })
  }
  
  useJsonld(() => ({
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbsList
  }))

  onMounted(() => {
    // must check if it is the Checkout page. On the Checkout page we have steps and every step need to write different dataLayer
    if (template.value !== 'Checkout') setDefaultDataLayer();
  });

  useHead(combinedHead.value)
  useSeoMeta(meta.value as any)
</script>
